import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { formatApiError } from '../../lib/api';

const Login = () => {
  const { user, checking, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (checking) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafafa] px-6" data-testid="admin-login-page">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white border border-gray-200 p-10"
        data-testid="admin-login-form"
      >
        <div className="mb-10">
          <p className="text-xs font-light tracking-[0.25em] text-gray-500 uppercase mb-2">smarch</p>
          <h1 className="text-3xl font-light tracking-tight">Administration</h1>
          <p className="text-sm font-light text-gray-500 mt-2">
            Connectez-vous pour gérer le contenu du site.
          </p>
        </div>

        <label className="block mb-5">
          <span className="block text-xs font-light tracking-wider uppercase text-gray-500 mb-2">
            Email
          </span>
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-gray-300 px-3 py-2 font-light focus:outline-none focus:border-[#d94e47] transition-colors"
            data-testid="admin-login-email"
          />
        </label>

        <label className="block mb-8">
          <span className="block text-xs font-light tracking-wider uppercase text-gray-500 mb-2">
            Mot de passe
          </span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-300 px-3 py-2 font-light focus:outline-none focus:border-[#d94e47] transition-colors"
            data-testid="admin-login-password"
          />
        </label>

        {error && (
          <div
            className="mb-6 border-l-2 border-[#d94e47] bg-red-50 px-4 py-3 text-sm font-light text-[#d94e47]"
            data-testid="admin-login-error"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-black text-white py-3 text-sm font-light tracking-wider uppercase hover:bg-[#d94e47] transition-colors disabled:opacity-50"
          data-testid="admin-login-submit"
        >
          {submitting ? 'Connexion...' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
};

export default Login;
